import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { hasPendingB2cRedirect, hasPendingMsalInteraction } from '../auth.config';

@Injectable({ providedIn: 'root' })
export class VersionCheckService {

  currentVersion: string | null = null;
  versionUrl = '/assets/version.json';

  constructor(private http: HttpClient) {}

  initVersionCheck() {

    this.http.get(this.versionUrl).subscribe((data: any) => {
      this.currentVersion = data.version;
    });

    setInterval(() => {
      this.checkVersion();
    }, 30000); // every 30 seconds
  }

  checkVersion() {
    if (hasPendingB2cRedirect() || hasPendingMsalInteraction()) {
      return;
    }
    this.http.get(this.versionUrl).subscribe((data: any) => {
      const latestVersion = data.version;

      if (this.currentVersion && latestVersion !== this.currentVersion) {
        console.log('New version detected. Reloading...');
        window.location.reload();
      }
    });
  }
}
